export var SignalLvl;
(function (SignalLvl) {
    SignalLvl[SignalLvl["offline"] = 0] = "offline";
    SignalLvl[SignalLvl["marginal"] = 1] = "marginal";
    SignalLvl[SignalLvl["ok"] = 2] = "ok";
    SignalLvl[SignalLvl["good"] = 3] = "good";
    SignalLvl[SignalLvl["excellent"] = 4] = "excellent";
})(SignalLvl || (SignalLvl = {}));
